import React from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import { translateThis } from '../../helpers/language.helper';
import './custom.scss';
import ContactForm from '../../components/contactForm/ContactForm';




const JoinOurCommunityPage = () => {
    // custom home functions here
    const pageName = "Join Our Community";

    

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper joinOurCommunity-main-wrapper f-wrp">
                <div className='joinOurCommunity-banner-wrapper f-wrp'>
                    <div className='banner-content-wrp f-wrp'>
                        <span className='banner-main-img'><img src={AppIcons.joinCommunityBanner} alt='Join Our Community' /></span>
                        <div className='banner-content-box f-wrp'>
                            <h1>{translateThis("Join our community and become a volunteer")}</h1>
                        </div>
                    </div>
                </div>

                <div className='joinOurCommunity-form-wrapper contact-main-wrp f-wrp'>
                    <div className='main-container-wrp contact-main-container'>
                        <div className='contact-form-wrp f-wrp'>
                            <ContactForm />
                        </div>
                    </div>
                </div>
                <div className='community-need-wrp f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='community-need-con f-wrp'>
                            <div className='community-con-box f-wrp'>
                                <h1>{translateThis("We need volunteers to help us develop projects or to commit themselves on a long-term basis.")}</h1>
                                <p>{translateThis("we need volunteers para1")} </p>
                                <p>{translateThis("we need volunteers para2")} </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='community-vision-wrp f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='community-vision-con f-wrp'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className='community-vision-box f-wrp'>
                                        <h1>{translateThis('Join your hand with ours for a better life and future')}</h1>
                                        <div className='btn-wrp'>
                                            <Link to={'/contact-us'} className='sqr-btn'>{translateThis("Get involved")}</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className='community-vision-img f-wrp'>
                                        <span className='vision-img'><img src={AppIcons.joinCommunityVision} alt='join your hand with us' /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>










































            </div>
        </AppLayout>
    )
}

export default JoinOurCommunityPage;